<template lang="html">
  <div class="candle__step-content">
    <FormData
      type-form="candle"
      @submitForm="submitForm"
      @cancelSubmit="cancelSubmit"
    />
  </div>
</template>

<script>
import FormData from '@/components/Form/FormData.vue';

export default {
  name: 'CandleFormStep3',
  components: {
    FormData,
  },
  methods: {
    submitForm() {
      this.$store.commit('donationCandles/setPassedStep', 3);
      this.$store.commit('donationCandles/setCurrentStep', 4);
    },
    cancelSubmit() {
      this.$store.commit('donationCandles/setCurrentStep', 2);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'styles';
</style>
